module.exports = __webpack_public_path__ + "img/top_background.b7dafebb.jpeg";